function startupDeadlines() {
    const allDeadlines = [
        ...document.querySelectorAll('.deadline-item:not(.hidden)'),
    ];

    const allDeadlineToggles = [
        ...document.querySelectorAll('.deadline-toggle'),
    ];

    allDeadlineToggles.forEach((deadlineToggle) => {
        let active = false;
        deadlineToggle.addEventListener('click', () => {
            active = !active;

            const deadlineParent = deadlineToggle.closest('.deadline-parent');
            const deadlineWrapper =
                deadlineParent.querySelector('.deadline-wrapper');

            deadlineWrapper.style.maxHeight = active
                ? `${deadlineWrapper.scrollHeight}px`
                : '0px';
            deadlineWrapper.classList.toggle('mt-4');
            deadlineToggle.children[0].classList.toggle('-rotate-180');
        });
    });
}

startupDeadlines();

window.startupDeadlines = startupDeadlines;
